export const TOAST_TRANSFORMS = {
  toast: {
    in: 'translateX(0)',
    out: 'translateX(-100%)'
  },
  inline: {
    in: 'translate(-50%, 0)',
    out: 'translate(-50%, -100%)'
  }
};

export const TIME_TO_DELETE = 300;
export const TIME_TO_LIVE = 5000;
